const ddadosCnae = {
  Titulo: "CNAE",
  Campos: {
    //DDados CNAE
    SuggestionCnae: {
      Tipo: "multipleselect",
      Label: "CNAE",
      Tooltip: "Código - CNAE",
      Placeholder: "Código - CNAE",
    },
  },
};

export { ddadosCnae };
